var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{staticClass:"library-filter-checkbox-button",attrs:{"outlined":!_vm.input,"color":_vm.input ? 'primary' : '',"disabled":_vm.disabled},on:{"click":_vm.triggerChange}},[_vm._v(_vm._s(_vm.label)+" "),_c('span',{staticClass:"counter ms-1"},[_vm._v(_vm._s(_vm.counter))])])
}
var staticRenderFns = []

export { render, staticRenderFns }